// extracted by mini-css-extract-plugin
export default {"wrapper":"Or12LzSa_bnJ5Mv2LGPB"};